import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _UserLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M19.727 20.447c-.455-1.276-1.46-2.403-2.857-3.207S13.761 16 12 16s-3.473.436-4.87 1.24-2.402 1.931-2.857 3.207" }),
            React.createElement("circle", { cx: 12, cy: 8, r: 4, stroke: "currentColor", strokeLinecap: "round" })));
}
const UserLight = forwardRef(_UserLight);
export { UserLight };
